import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { WrappedLabelsIcon } from '../../../../../../../styles';
import { StyledIconButton } from './shared-styles';

interface WrappedXAxisLabelsToggleProps {
  onClick: () => void;
}

export const WrappedXAxisLabelsToggle = (
  props: WrappedXAxisLabelsToggleProps
) => {
  const { onClick } = props;
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Tooltip
      title={t('common:commonValues.tooltips.toggleWrappedAxisLabels')}
      placement="top"
    >
      <StyledIconButton
        onClick={handleClick}
        size="small"
        aria-label="Toggle Multi-line Labels"
      >
        <WrappedLabelsIcon />
      </StyledIconButton>
    </Tooltip>
  );
};
